import { createContext, useContext, useState, useEffect } from "react";
import cartAPI from "../api/cartApi";
import { showError, showSuccess } from "../utils/toastUtils";

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);
  const [cartSummary, setCartSummary] = useState({
    subtotal: "",
    discount: "",
    shipping: "",
    total: "",
    couponCode: "",
  });

  useEffect(() => {
    fetchCart();
  }, []);

  const fetchCart = async () => {
    try {
      const res = await cartAPI.fetchCart();
      if (res.code === 200) {
        const result = res.data;

        setCartItems([...result?.items]);
        setCartSummary({ ...result?.summary });
      }
    } catch (err) {
      console.log("No Data");
    }
  };

  const addToCart = async (productId, quantity = 1, variantId = null , customization = {}) => {
    const payload = {
      productId,
      quantity,
      variantId,
       customization,
    };

    try {
      const res = await cartAPI.addCart(payload);

      if (res.code === 200) {
        const result = res.data;

        showSuccess(res.message);

        if (!localStorage.getItem("x-guest-session-id")) {
          localStorage.setItem("x-guest-session-id", result.sessionId);
        }

        fetchCart();
      } else {
        showError(res.message);
      }
    } catch (err) {}
  };

  const updateQuantity = async (itemId, quantity) => {
    try {
      const res = await cartAPI.updateQuantity(itemId, { quantity });
      if (res.code === 200) {
        fetchCart();
      } else {
        showError(res.message);
      }
    } catch (err) {}
  };

  const removeItem = async (id) => {
    try {
      const res = await cartAPI.removeItem(id);

      if (res.code === 200) {
        fetchCart();
      } else {
        showError(res.message);
      }
    } catch (err) {}
  };

  return (
    <CartContext.Provider
      value={{
        cartItems,
        cartSummary,
        addToCart,
        fetchCart,
        updateQuantity,
        removeItem,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
